import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	drawerOpen: false,
};

export const globalSlice = createSlice({
	name: "global",
	initialState,
	reducers: {
		setGlobalState: {
			prepare(stateName, stateValue) {
				return {
					payload: { stateName, stateValue },
				};
			},
			reducer(state, action) {
				const { stateName, stateValue } = action.payload;
				state[stateName] = stateValue;
			},
		},
	},
});

export const { setGlobalState } = globalSlice.actions;
export default globalSlice.reducer;
